import { delay } from 'q'
import {
	ServiceProvider,
	ServiceProviderServiceInterface,
	ListResponse,
	Reseller,
	SingleResponse,
	User,
	UserFormValues,
	ReportEntry, ServiceProvidersLicenseUsage, ResellerLicense
} from '../types'
import serviceProviders from './fakes/serviceProviders'
import { createFakeListResponse, createFakeSingleResponse } from './fakes/createFakeResponse'
import users from './fakes/users'
import report from './fakes/report'
import licenseUsageReport from './fakes/serviceProviderLicenseUsageReport'

export default class MockServiceProviderService implements ServiceProviderServiceInterface {
	async getById(id: number): Promise<SingleResponse<ServiceProvider>> {
		await delay(500)
		return createFakeSingleResponse(serviceProviders.filter(sp => sp.id === id)[0])
	}

	async getAll(): Promise<ListResponse<ServiceProvider>> {
		await delay(500)
		return createFakeListResponse(serviceProviders)
	}

	public async getChildren(): Promise<ListResponse<Reseller>> {
		return createFakeListResponse([])
	}

	public async getUsers(): Promise<ListResponse<User>> {
		return createFakeListResponse(users)
	}

	public async updateUserForServiceProvider(id: number, userId: number, values: UserFormValues): Promise<SingleResponse<User>> {
		await delay(500)
		const index = users.findIndex(user => user.id === userId)
		users[index] = {
			...users[index],
			email: values.email,
			name: values.name,
		}
		return createFakeSingleResponse(users[index])
	}

	public async deleteUserForServiceProvider(id: number, userId: number): Promise<void> {
		await delay(500)
		const index = users.findIndex(user => user.id === userId)
		users.splice(index, 1)
	}

	public async updateTemplateIdForServiceProvider(id: number, templateId: string): Promise<SingleResponse<ServiceProvider>> {
		await delay(500)
		const index = serviceProviders.findIndex(serviceProvider => serviceProvider.id === id)
		serviceProviders[index] = {
			...serviceProviders[index],
			template_id: templateId,
			template_url: `https://some-url.com/${templateId}`
		}
		return createFakeSingleResponse(serviceProviders[index])
	}

	public async getReport(): Promise<ListResponse<ReportEntry>> {
		await delay(500)
		return createFakeListResponse(report)
	}

	public async getCsvReport(): Promise<SingleResponse<string>> {
		await delay(500)
		return createFakeSingleResponse('')
	}

	public async getLicenseUsageReport(): Promise<SingleResponse<ServiceProvidersLicenseUsage[]>> {
		await delay(500)
		return createFakeSingleResponse([licenseUsageReport])
	}

	public async getLicenses(): Promise<SingleResponse<Record<string, ResellerLicense>>> {
		return {
			data: {
				CRM: {
					id: 1,
					type: 'CRM',
					allocated: 10,
					consumed: 10,
					display_name: 'CRM',
					is_limit_enabled: true,
					limit: 10,
					is_nfr: false,
				}
			}
		}
	}

	public async updateLicense(): Promise<void> {
		return
	}
}
